import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

/**
 * Placeholder for the Payouts tab.
 *
 * Spec: /agent-os/specs/2026-06-10-deferred-capture-admin-approval/spec.md (§ 5.3.1)
 *
 * V1 leaves the payouts list deferred — the spec calls it out as
 * "could ship in a second phase." The Hub-side `POST /admin/payments/
 * payouts/:id/release` (early-release with reason) already exists +
 * is wired into the payment-detail page; what's missing is a
 * dedicated list view that aggregates transferred + scheduled payouts
 * with pilot-org filters. Placeholder reserves the slot.
 */
@Component({
  selector: 'app-payouts-placeholder',
  standalone: true,
  imports: [CommonModule],
  template: `
    <div class="text-center py-5 text-muted">
      <i class="bi bi-send-check display-4 d-block mb-3 text-secondary"></i>
      <h5 class="mb-2 text-body">Payouts — Coming soon</h5>
      <p class="mb-1" style="max-width: 480px; margin: 0 auto;">
        Track Stripe Connect transfers to pilots — scheduled, in-flight,
        and completed. Includes overage payouts (separate from base) and
        admin-triggered early releases.
      </p>
      <p class="small text-muted mt-3 mb-0">
        For now, payout state lives on each payment's detail page under
        the lifecycle timeline.
      </p>
    </div>
  `,
})
export class PayoutsPlaceholderComponent {}
